import { render, staticRenderFns } from "./evaTask.vue?vue&type=template&id=2af0a5d8&scoped=true&"
import script from "./evaTask.vue?vue&type=script&lang=js&"
export * from "./evaTask.vue?vue&type=script&lang=js&"
import style0 from "./evaTask.vue?vue&type=style&index=0&id=2af0a5d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af0a5d8",
  null
  
)

export default component.exports